import { GetMarkFileRequestModel } from '../kymw1501/vo/get-mark-file-request.model';
import { MarkFileRequestModel } from '../kymw1502/vo/mark-file-request.model';
import { PlessViewUtilsSub } from '../../../commons/kymw00/pless-view-utils-sub.service';
import { MarkFile } from './vo/mark-file.model';
import { MarkFileForView } from './vo/mark-file-for-view.model';
import { CwsIconData } from './vo/cws-icon-data.model';
import { CwsIconDataForView } from './vo/cws-icon-data-for-view.model';
import { MarkConvInfo } from './vo/mark-conv-info.model';
import { MarkConvInfoForView } from './vo/mark-conv-info-for-view.model';
import { CwsIconConvInfo } from './vo/cws-icon-conv-info.model';
import { CwsIconConvInfoForView } from './vo/cws-icon-conv-info-for-view.model';

/**
 * マーク管理画面の値を管理するクラス
 *
 * @export KYMW1500Model
 * @class KYMW1500Model
 */
export class KYMW1500Model {
  /** 共通 */
  /** マークグループリスト */
  public markGroupList = [];
  public selectedMarkGroup: string = <string>'';

  /** マークタブ */
  // マーク名
  public markName: string = <string>'';
  // マークファイル名
  public markFileName: string = <string>'';
  // マークグループコード
  public markGroupCode: string = <string>'';
  // マーク区分
  public supplyPromoteMarkDiv: string = <string>'';
  // マーク名登録日(FROM)
  public registMarkDateFrom: string = <string>'';
  // マーク名登録日(TO)
  public registMarkDateTo: string = <string>'';
  // マークファイル登録日(FROM)
  public fileRegistDateFrom: string = <string>'';
  // マークファイル登録日(TO)
  public fileRegistDateTo: string = <string>'';
  // マークファイル未登録のみ　※0：未登録ファイル以外も含む 、1：未登録ファイルのみ
  public fileNonRegistOnly: string = <string>'0';
  // 使用停止マークのみ　※0：使用、1：使用停止
  public unabledOnly: string = <string>'0';

  // マークファイルリスト
  public markFileList: MarkFile[] = [];
  // マークファイルリスト 表示用
  public markFileListForView: MarkFileForView[] = [];
  // マークファイルリスト件数
  public markFileNum: number = <number>0;

  // 販売促進マークリスト
  public supplyPromoteMarkDivList = [];
  public selectedSupplyPromoteMarkDiv: string = <string>'';

  // 使用終了マーク表示
  public displayEndMark: boolean = <boolean>false;

  // 権限制御
  public registMarkBtnDisabled: boolean = <boolean>false;
  public registMarkFileBtnDisabled: boolean = <boolean>false;

  /** アイコンタブ */
  // アイコン情報リスト
  public cwsIconDataList: CwsIconData[] = [];
  // アイコン情報リスト 表示用
  public cwsIconDataListForView: CwsIconDataForView[] = [];
  // アイコン情報リスト件数
  public cwsIconDataNum: number = <number>0;

  // 使用終了マーク表示
  public displayEndCwsIconData: boolean = <boolean>false;

  // 権限制御
  public registCwsIconDataBtnDisabled: boolean = <boolean>false;

  /** 関連タブ */
  // ラジオボタン
  public radioBtnValue: string = <string>'1';
  // 一覧の表示リスト名
  public displayListName: string = <string>'マーク一覧';
  // マーク変換情報リスト
  public markConvInfoList: MarkConvInfo[] = [];
  // マーク変換情報リスト 表示用
  public markConvInfoListForView: MarkConvInfoForView[] = [];

  // アイコン変換情報リスト
  public cwsIconConvInfoList: CwsIconConvInfo[] = [];
  // アイコン変換情報リスト 表示用
  public cwsIconConvInfoListForView: CwsIconConvInfoForView[] = [];
  // アイコン変換情報 セットリスト
  public selectedCwsIconDataList: string[] = [];

  // 権限制御
  public updateMarkOrCwsIconBtnDisabled: boolean = <boolean>false;

  /**  kymw1501画面用の受渡Vo  */
  kymw1501InputVO = new GetMarkFileRequestModel();
  // /**  kymw1502画面用の受渡Vo  */
  // kymw1502InputVO = new MarkFileRequestModel();

  /**
   * マークグループリストを更新する
   *
   * @param serverData マークグループリストのサーバ取得データ
   */
  public updateMarkGroupList(serverData: any) {
    if (PlessViewUtilsSub.isEmpty(serverData)) {
      this.markGroupList = [];
      return;
    }
    this.markGroupList = this.createComboboxArray(serverData, {
      MarkGroupCode: '',
      Caption: '',
    });
    this.kymw1501InputVO.markGroupList = this.markGroupList;
  }

  /**
   * 販売促進マークリストを更新する
   *
   * @param serverData 販売促進マークリストのサーバ取得データ
   */
  public updateSupplyPromoteMarkDivList(serverData: any): void {
    if (PlessViewUtilsSub.isEmpty(serverData)) {
      this.supplyPromoteMarkDivList = [];
      return;
    }
    this.supplyPromoteMarkDivList = this.createComboboxArray(serverData, {
      CodeValue: '',
      CodeName: '',
    });
    this.kymw1501InputVO.supplyPromoteMarkDivList =
      this.supplyPromoteMarkDivList;
  }

  /**
   * コンボボックス用配列の作成
   *
   * @private
   * @param {*} comboboxDataArray サーバから取得されたコンボボックス用データ
   * @param {*} blankData 先頭の空白用データ
   * @returns {*}　コンボボックス用配列
   * @memberof KYMW1500Model
   */
  private createComboboxArray(comboboxDataArray: any, blankData: any): any {
    let tempList = [];
    tempList = comboboxDataArray;
    tempList.splice(0, 0, blankData);
    return tempList;
  }

  /**
   * マークグループコードに対応するマークグループ名を取得する
   *
   * @param markGroupCode マークグループコード
   * @return マークグループ名
   */
  public getMarkGroupCaption(markGroupCode: string): string {
    const target = this.markGroupList.find(markGroup => {
      return markGroupCode === markGroup.MarkGroupCode;
    });

    return PlessViewUtilsSub.isEmpty(target) ? '' : target.Caption;
  }

  /**
   * 供給促進マーク区分に対応する名称を取得する
   *
   * @param codeValue 供給促進マーク区分
   * @return 供給促進マーク区分の名称
   */
  public getSupplyPromoteMarkDivName(codeValue: string): string {
    const target = this.supplyPromoteMarkDivList.find(supplyPromoteMarkDiv => {
      return codeValue === supplyPromoteMarkDiv.CodeValue;
    });

    return PlessViewUtilsSub.isEmpty(target) ? '' : target.CodeName;
  }

  /**
   * データグリッド「マークファイル一覧」を設定する
   *
   * @returns {void}
   * @memberof KYMW1500Model
   */
  public updateMarkFileList(
    displayEndMarkFlg: boolean,
    callback?: Function
  ): void {
    if (this.markFileList.length === 0) {
      this.markFileListForView = [];
      this.markFileNum = 0;
      return;
    }

    const today = new Date();
    if (!displayEndMarkFlg) {
      this.markFileListForView = this.markFileList.reduce(
        (viewList, markFile) => {
          // ※配達終了日が空文字""の場合、使用中と捉える
          if (PlessViewUtilsSub.isEmpty(markFile.delivEndDate) || 
            new Date(PlessViewUtilsSub.editDate(markFile.delivEndDate, '2')) > today) {
            viewList.push(
              new MarkFileForView(
                PlessViewUtilsSub.editDate(markFile.delivEndDate, '2'),
                markFile.markGroupCode,
                this.getMarkGroupCaption(markFile.markGroupCode),
                PlessViewUtilsSub.zeroPadding(3, markFile.markCode),
                markFile.markCodeBranch,
                markFile.markName,
                markFile.markFileUrl,
                markFile.markFileName,
                this.decodeString(
                  markFile.startOrderCode,
                  '0000000',
                  '指定なし'
                ),
                this.decodeString(markFile.startDelivCatalogId, null, ''),
                this.decodeString(markFile.endOrderCode, '9999999', '指定なし'),
                this.decodeString(markFile.endDelivCatalogId, null, ''),
                this.getSupplyPromoteMarkDivName(markFile.supplyPromoteMarkDiv),
                PlessViewUtilsSub.editDate(markFile.registDate, '2'),
                PlessViewUtilsSub.editDate(markFile.fileRegistDate, '2'),
                false
              )
            );
          }
          return viewList;
        },
        []
      );
    } else {
      this.markFileListForView = this.markFileList.reduce(
        (viewList, markFile) => {
          viewList.push(
            new MarkFileForView(
              PlessViewUtilsSub.editDate(markFile.delivEndDate, '2'),
              markFile.markGroupCode,
              this.getMarkGroupCaption(markFile.markGroupCode),
              PlessViewUtilsSub.zeroPadding(3, markFile.markCode),
              markFile.markCodeBranch,
              markFile.markName,
              markFile.markFileUrl,
              markFile.markFileName,
              this.decodeString(markFile.startOrderCode, '0000000', '指定なし'),
              this.decodeString(markFile.startDelivCatalogId, null, ''),
              this.decodeString(markFile.endOrderCode, '9999999', '指定なし'),
              this.decodeString(markFile.endDelivCatalogId, null, ''),
              this.getSupplyPromoteMarkDivName(markFile.supplyPromoteMarkDiv),
              PlessViewUtilsSub.editDate(markFile.registDate, '2'),
              PlessViewUtilsSub.editDate(markFile.fileRegistDate, '2'),
              (PlessViewUtilsSub.isEmpty(markFile.delivEndDate) ||
                new Date(PlessViewUtilsSub.editDate(markFile.delivEndDate, '2')) > today) ? false : true
            )
          );
          return viewList;
        },
        []
      );
    }

    this.markFileNum = this.markFileListForView.length;
    if (callback) {
      setTimeout(() => {
        callback();
      }, 500);
    }
  }

  /**
   * データグリッド「アイコン情報一覧」を設定する
   *
   * @returns {void}
   * @memberof KYMW1500Model
   */
  public updateCwsIconDataList(
    displayEndCwsIconData: boolean,
    callback?: Function
  ): void {
    if (this.cwsIconDataList.length === 0) {
      this.cwsIconDataListForView = [];
      this.cwsIconDataNum = 0;
      return;
    }

    const today = new Date();
    if (!displayEndCwsIconData) {
      this.cwsIconDataListForView = this.cwsIconDataList.reduce(
        (viewList, cwsIconData) => {
          // ※配達終了日が空文字""の場合、使用中と捉える
          if (PlessViewUtilsSub.isEmpty(cwsIconData.delivEndDate) || 
            new Date(PlessViewUtilsSub.editDate(cwsIconData.delivEndDate, '2')) > today) {
            viewList.push(
              new CwsIconDataForView(
                PlessViewUtilsSub.editDate(cwsIconData.delivEndDate, '2'),
                cwsIconData.iconGroupCode,
                this.getMarkGroupCaption(cwsIconData.iconGroupCode),
                PlessViewUtilsSub.zeroPadding(3, cwsIconData.iconCode),
                PlessViewUtilsSub.zeroPadding(2, cwsIconData.iconCodeBranch),
                cwsIconData.iconName,
                cwsIconData.iconImageUrl,
                cwsIconData.iconAlternativeText,
                this.decodeString(cwsIconData.delivCatalogIdStart, null, ''),
                this.decodeString(cwsIconData.delivCatalogIdEnd, null, ''),
                cwsIconData.iconDiv,
                cwsIconData.arrangeDiv,
                cwsIconData.iconExplain,
                this.convertOutputDiv(cwsIconData.outputDiv),
                false,
                cwsIconData.updateDate
              )
            );
          }
          return viewList;
        },
        []
      );
    } else {
      this.cwsIconDataListForView = this.cwsIconDataList.reduce(
        (viewList, cwsIconData) => {
          viewList.push(
            new CwsIconDataForView(
              PlessViewUtilsSub.editDate(cwsIconData.delivEndDate, '2'),
              cwsIconData.iconGroupCode,
              this.getMarkGroupCaption(cwsIconData.iconGroupCode),
              PlessViewUtilsSub.zeroPadding(3, cwsIconData.iconCode),
              PlessViewUtilsSub.zeroPadding(2, cwsIconData.iconCodeBranch),
              cwsIconData.iconName,
              cwsIconData.iconImageUrl,
              cwsIconData.iconAlternativeText,
              this.decodeString(cwsIconData.delivCatalogIdStart, null, ''),
              this.decodeString(cwsIconData.delivCatalogIdEnd, null, ''),
              cwsIconData.iconDiv,
              cwsIconData.arrangeDiv,
              cwsIconData.iconExplain,
              this.convertOutputDiv(cwsIconData.outputDiv),
              (PlessViewUtilsSub.isEmpty(cwsIconData.delivEndDate) ||
                new Date(PlessViewUtilsSub.editDate(cwsIconData.delivEndDate, '2')) > today) ? false : true,
              cwsIconData.updateDate,
            )
          );
          return viewList;
        },
        []
      );
    }

    this.cwsIconDataNum = this.cwsIconDataListForView.length;
    if (callback) {
      setTimeout(() => {
        callback();
      }, 500);
    }
  }

  /**
   * データグリッド「マーク変換情報一覧」を設定する
   *
   * @returns {void}
   * @memberof KYMW1500Model
   */
  public updateMarkConvInfoList(callback?: Function): void {
    if (this.markConvInfoList.length === 0) {
      this.markConvInfoListForView = [];
      return;
    }

    this.markConvInfoListForView = this.markConvInfoList.reduce(
      (viewList, markConvInfo) => {
        if (!PlessViewUtilsSub.isEmptyArray(markConvInfo.markList)) {
          for (const mark of markConvInfo.markList) {
            viewList.push(
              new MarkConvInfoForView(
                PlessViewUtilsSub.zeroPadding(3, markConvInfo.iconCode),
                this.getMarkGroupCaption(markConvInfo.iconGroupCode),
                markConvInfo.iconName,
                PlessViewUtilsSub.zeroPadding(2, markConvInfo.iconCodeBranch),
                markConvInfo.iconImageUrl,
                mark.markFileName ? mark.markFileName : '',
                mark.markFileUrl ? mark.markFileUrl : ''
              )
            );
          }
        } else {
          viewList.push(
            new MarkConvInfoForView(
              PlessViewUtilsSub.zeroPadding(3, markConvInfo.iconCode),
              this.getMarkGroupCaption(markConvInfo.iconGroupCode),
              markConvInfo.iconName,
              PlessViewUtilsSub.zeroPadding(2, markConvInfo.iconCodeBranch),
              markConvInfo.iconImageUrl,
              '',
              ''
            )
          );
        }
        return viewList;
      },
      []
    );
    if (callback) {
      setTimeout(() => {
        callback();
      }, 500);
    }
  }

  /**
   * データグリッド「アイコン変換情報一覧」を設定する
   *
   * @returns {void}
   * @memberof KYMW1500Model
   */
  public updateCwsIconConvInfoList(callback?: Function): void {
    if (this.cwsIconConvInfoList.length === 0) {
      this.cwsIconConvInfoListForView = [];
      return;
    }

    this.cwsIconConvInfoListForView = this.cwsIconConvInfoList.reduce(
      (viewList, cwsIconConvInfo) => {
        if (!PlessViewUtilsSub.isEmptyArray(cwsIconConvInfo.iconList)) {
          for (const icon of cwsIconConvInfo.iconList) {
            viewList.push(
              new CwsIconConvInfoForView(
                PlessViewUtilsSub.zeroPadding(3, cwsIconConvInfo.markCode),
                this.getMarkGroupCaption(cwsIconConvInfo.markGroupCode),
                cwsIconConvInfo.markName,
                PlessViewUtilsSub.zeroPadding(
                  2,
                  cwsIconConvInfo.markCodeBranch
                ),
                cwsIconConvInfo.markFileUrl,
                icon.iconFileName ? icon.iconFileName : '',
                icon.iconUrl ? icon.iconUrl : ''
              )
            );
          }
        } else {
          viewList.push(
            new CwsIconConvInfoForView(
              PlessViewUtilsSub.zeroPadding(3, cwsIconConvInfo.markCode),
              this.getMarkGroupCaption(cwsIconConvInfo.markGroupCode),
              cwsIconConvInfo.markName,
              PlessViewUtilsSub.zeroPadding(2, cwsIconConvInfo.markCodeBranch),
              cwsIconConvInfo.markFileUrl,
              '',
              ''
            )
          );
        }
        return viewList;
      },
      []
    );
    if (callback) {
      setTimeout(() => {
        callback();
      }, 500);
    }
  }

  /**
   * 対象が特定の文字列の場合、指定の文字列に置き換える
   *
   * @param {String} target 処理対象の文字列
   * @param {String} check 検索する文字列
   * @param {String} swap 置換する文字列
   * @returns {String} 置換後の文字列
   * @memberof KYMW1500Model
   */
  private decodeString(target: string, check: string, swap: string): string {
    if (target === check) {
      return swap;
    }
    return target;
  }

  /**
   * 出力区分の01010101といった形式の値をを表示用の値に変換する
   *
   * @param outputDiv 出力区分
   */
  private convertOutputDiv(outputDiv: string): string {
    // 出力区分
    // 右から1文字目：商品マスタ、2文字目：ウィークリー、3文字目：デイリー、
    // 4文字目：スポット、5文字目：見切り品、6文字目：注文確認画面表示対象フラグ、
    // 7文字目：予備、8文字目：予備
    // 0：表示しない、1：表示する
    // ※ 以下パラメータについては値として返却しているが、フロントエンド側での使用を想定していない
    // 4文字目：スポット
    // 7文字目：予備
    // 8文字目：予備
    const outputDivMap = {
      1: '商品マスタ',
      2: 'ウィークリー',
      3: 'デイリー',
      4: '',
      5: '見切り品',
      6: '注文確認画面表示対象フラグ',
      7: '',
      8: '',
    };

    let resultList: string[] = [];
    const outputDivList = outputDiv.split('');
    outputDivList.reverse();
    for (var i = 0; i < outputDivList.length; i++) {
      if (outputDivList[i] === '1') {
        if (outputDivMap[i + 1] !== '') {
          resultList.push(outputDivMap[i + 1]);
        }
      }
    }
    return resultList.join(', ');
  }
}
